import React, { Component } from 'react'

import { SVGView } from '../assets-view/SVGView'
import DocumentView from '../document-view/DocumentView'
import fileextension from 'file-extension'
import VideoView from '../assets-view/VideoView'
import AudioView from '../assets-view/AudioView'
import { AUDIO_EXT, handleSetSrc } from '../../utils/index'
import "./AttachedFile.css"
class AttachedFile extends Component {


    constructor(props) {
        super(props)
        this.state = {}
    }


    render() {
        const { attachedFile } = this.props
        return (
            <React.Fragment>
                <div className="box-attachedFile">
                    <div className="attachedFile-view">



                        {attachedFile.type === 'image' && fileextension(attachedFile.originalURL) === 'svg' &&
                            <div className="img-wrapper-2">
                                <SVGView comFromMiddleView={true} src={attachedFile.originalURL} assetId={attachedFile._id} />
                            </div>
                        }
                        {attachedFile.type === 'image' && fileextension(attachedFile.originalURL) !== 'svg' &&
                            <div className="img-wrapper-2">
                                <img
                                    className="img-asset-comment-2"
                                    alt={attachedFile.name}
                                    src={handleSetSrc(attachedFile)}
                                />
                            </div>
                        }
                        {attachedFile.type === 'document' &&
                            AUDIO_EXT.includes(fileextension(attachedFile.originalURL)) &&
                            <div className="fixed_wrapper">
                                <AudioView item={attachedFile} from={`middleView`} canCommentsAndVersions={true} isComment={true} />
                            </div>
                        }

                        {attachedFile.type === 'document' &&
                            !AUDIO_EXT.includes(fileextension(attachedFile.originalURL))
                            &&
                            <div className="img-wrapper-2">
                                <DocumentView item={attachedFile} from={`comments`} />
                            </div>

                        }
                        {attachedFile.type === 'video' &&
                            <div className="fixed_wrapper">
                                <VideoView
                                    url={attachedFile.lowQualityURL}
                                    disableDefaultControls={false}
                                    autoPlay={false}
                                    muted={true}
                                />
                            </div>
                        }


                    </div>
                </div>


            </React.Fragment>
        )

    }


}

export default AttachedFile